import {GtmEnum} from "../../core/models/gtm.enum";

export class OrderTrackingEntry {
  public ts: string;
  public transactionId: string;
  public eventType: string;
  public eventData: any[];
}
